export { DiagnosisType } from './generated/DiagnosisType.js';